export const EVALUATION_SHORT_LABELS = {
  question1: "Limpieza",
  question2: "Amabilidad",
  question3: "Rapidez",
  question4: "Ayuda",
  question5: "Solución",
};

export const getEvaluationShortLabel = (questionId, fallback = "Sin nombre") =>
  EVALUATION_SHORT_LABELS[questionId] || fallback;
